import Button from '@mui/material/Button';
import * as React from 'react';

interface AppBarButtonProps {
    disabled: boolean;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    label?: string;
    icon: React.ReactNode;
}

export const AppBarButton: React.FC<AppBarButtonProps & React.RefAttributes<HTMLButtonElement | null>> = React.forwardRef((props, ref) => {
    return (
        <Button
            ref={ref}
            sx={{
                lineHeight: '1.2em',
                fontWeight: 600,
            }}
            onClick={props.onClick}
            disabled={props.disabled}
            data-testid={`appbar-${props.label ?? 'noLabel'}`}
        >
            {props.icon}
            {props.label}
        </Button>
    );
});
